import { QueryClientProvider } from '@tanstack/react-query';
import { useEffect, useState, type ReactNode } from 'react';

import { useAuth } from './auth.js';
import { createQueryClient } from './query.js';
import { sessionIdentity } from './sessionIdentity.js';

/** 每个身份/工作区拥有独立缓存；key 变化时同时重置组件里的私有 state。 */
export function SessionQueryProvider({ children }: { children: ReactNode }) {
  const { admin, isCheckingIdentity } = useAuth();
  return (
    <div style={{ display: isCheckingIdentity ? 'none' : 'contents' }}>
      <SessionQueries key={sessionIdentity(admin)}>{children}</SessionQueries>
    </div>
  );
}

function SessionQueries({ children }: { children: ReactNode }) {
  const [client] = useState(createQueryClient);
  useEffect(
    () => () => {
      void client.cancelQueries();
      client.clear();
    },
    [client],
  );
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
